// Base URLs for API endpoints
// LIVE URLS
export const baseUrl = "https://new-wapi.sandesh.com/api/v1/";
const baseUrlMenu = "https://new-wapi.sandesh.com/api/v1/menu/";
const baseUrlPage = "https://new-wapi.sandesh.com/api/v1/";
const PbaseUrl = "https://new-wapi.sandesh.com/api/v1/";

//QA URLS FOR EVENTS
// export const eventbaseurl ="https://api-sandesh-competition.nichetechqa.com/api/web"

//Live URLS FOR EVENTS
export const eventbaseurl = "https://eventadmin.sandesh.com/api/api/web";
export const eventbaseurlforimages =
  "https://sandesh-event.blr1.cdn.digitaloceanspaces.com";
export const razorpaykey = "rzp_live_5vwJM8c5PQfPgk";
// export const razorpaykey = "rzp_test_30MWR22aSr3oQn"
// const eventbaseurl ="http://192.168.0.156:5000/api/web"

// // //QA URLS
// export const baseUrl = "https://stage-wapi.sandesh.com/api/v1/";
// const baseUrlMenu = "https://stage-wapi.sandesh.com/api/v1/menu/";
// const baseUrlPage = "https://stage-wapi.sandesh.com/api/v1/";
// const PbaseUrl = "https://stage-wapi.sandesh.com/api/v1/";

// if live with search base url then pls look in header
export const Is_Live = true;

// Base URL for assets
export const assetbaseUrl = "https://epapercdn.sandesh.com/";

// HTTP service object containing various API endpoints
const HttpService = {
  // Page-specific endpoints
  ganesh: baseUrlPage + "ganesh/",
  baseurl: baseUrlPage + "page/",
  rssURL: baseUrlPage + "rss",
  // Menu endpoints
  metro: baseUrl + "menu/gujarat-metro",
  menu: baseUrlMenu + "web-menu",
  menuTabs: baseUrlMenu + "web-bottom-menu",
  footer: baseUrlMenu + "footer-menu",
  // General endpoints
  setting: baseUrl + "setting",
  invrel: baseUrl + "investor",
  gallary: PbaseUrl + "gallerypage",
  gallaryInner: PbaseUrl + "gallery/",
  homeSecondary: PbaseUrl + "home/secondary",
  homePrimary: PbaseUrl + "home/primary",
  post: PbaseUrl + "post-details",
  postMore: PbaseUrl + "post-related-details",
  videoInner: PbaseUrl + "video/",
  category: PbaseUrl + "category/",
  multiCategory: PbaseUrl + "multi-category",
  categoryLocation: PbaseUrl + "location/",
  tag: PbaseUrl + "tag/",
  forgetPassword: PbaseUrl + "forgot",
  updatepassword: PbaseUrl + "updatepassword",
  categoryAstro: PbaseUrl + "category/astrology",
  gujaratSamagraCity: PbaseUrl + "city",
  video: PbaseUrl + "videopage",
  loginCheck: PbaseUrl + "logincheck",
  otpCheck: PbaseUrl + "checkotp",
  signup: PbaseUrl + "register",
  login: PbaseUrl + "login",
  city: PbaseUrl + "city",
  cityResult: PbaseUrl + "cityresult/",
  tithi: PbaseUrl + "tithi",
  childMenu: PbaseUrl + "childmenu",
  horoscope: PbaseUrl + "horoscope",
  horoscopeDetail: PbaseUrl + "horoscope",
  gameZop: PbaseUrl + "gamezop",
  widget: PbaseUrl + "widget",
  epaperCategory: PbaseUrl + "e-paper?slug=",
  ePaperMenu: baseUrl + "menu/e-paper-menu",
  searchResult: PbaseUrl + "search",
  ePaperImage: PbaseUrl + "epaper-latest",
  googleResult: PbaseUrl + "sociallogin",
  ProfileResult: PbaseUrl + "profile",
  profileUpdateResult: PbaseUrl + "profileupdate",
  analytics: PbaseUrl + "analytics",
  openapp: PbaseUrl + "openapp",
  postComment: PbaseUrl + "post-comment",
  reportcomment: PbaseUrl + "report-comment",
  comment: PbaseUrl + "comments",
  videoCategory: PbaseUrl + "videocategory/",
  sportScore: PbaseUrl + "sportspage",
  marquee: PbaseUrl + "marquee",
  AllViewCount: PbaseUrl + "all-page-view",
  IncrementPostViews: PbaseUrl + "increment-post-views",
  event: eventbaseurl + "/getEvents",
  geteventbyid: eventbaseurl + "/getEventById?id=",
  geteventform: eventbaseurl + "/getEventFormByEventId?eventId=",
  getbanner: eventbaseurl + "/getBanners",
  submiteventform: eventbaseurl + "/registerEvent",
  createorderforpayment: eventbaseurl + "/create-order",
  verifyPayment: eventbaseurl + "/verifyPayment",
  WebStoryAPI: PbaseUrl + "latest-web-stories",
  WebStoryById: PbaseUrl + "webStoryById",
  webStoryAnalytics: PbaseUrl + "webStory-analytics",
  searchTag: PbaseUrl + "search-tag",
  HomePageWebStory: PbaseUrl + "home-page-web-story",
  IncrementWebStoryViews: PbaseUrl + "/increment-webstory-views",
  EPaperWatermarkDownload: PbaseUrl + "download-image-with-watermark",
  SearchCategoryResult: PbaseUrl + "category-for-search",
  investoRelations: PbaseUrl + "investor-relations",
  getPoll: PbaseUrl + "get-poll",
  PollVote: PbaseUrl + "poll-vote",
  LocalBodyOverAll: PbaseUrl + "election/overall-result",
  LocalBodyJillaPanchayat: PbaseUrl + "election/jilla-panchayat",
  LocalBodyTalukaPanchayat: PbaseUrl + "election/taluka",
  LocalBodyNagarPalika: PbaseUrl + "election/nagar-palika",
  LocalBodyCorporation: PbaseUrl + "election/corpo-data",
  cityDataNested: PbaseUrl + "election/city-data-nested",
  seatTally: PbaseUrl + "election/seat-tally",
  talukaGrouped: PbaseUrl + "taluka/grouped",
  talukaNews: PbaseUrl + "taluka/news",
};

export default HttpService;
// homePrimary action